export function removeQueryParamAndReplace(paramToRemove: string): void {
  const urlObject = new URL(window.location.href);
  urlObject.searchParams.delete(paramToRemove);
  const newUrl = urlObject.toString();
  window.history.replaceState({}, '', newUrl);
}
